'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../dist-es6/client/formatters');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseRealtimeUpdateController=require('../../../../dist-es6/client/angularCommon/baseRealtimeUpdateController');
const{UpdateFailedError:UpdateFailedError}=BaseRealtimeUpdateController;
const{SocketTimeoutError:SocketTimeoutError,UnexpectedError:UnexpectedError}=require('../../../../dist-es6/client/services/socketService');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const FatigueMeterType=require('../../../../dist-es6/shared/domain/fatigueMeterType');let

DashboardController=(_class=function(_BaseRealtimeUpdateCo){_inherits(DashboardController,_BaseRealtimeUpdateCo);
function DashboardController(
$scope,
$state,
$timeout,
$interval,
dateService,
breadcrumbsService,
dashboardDataService,
userService,
Analytics,
uncaughtErrorHandler,
groupTreeService,
fatigueMeterTypeContentProviderService,
timeZoneService,
paramSyncService)
{_classCallCheck(this,DashboardController);var _this=_possibleConstructorReturn(this,
_BaseRealtimeUpdateCo.call(this,uncaughtErrorHandler,$scope,$timeout,$interval,dateService,timespan.fromMinutes(5),timespan.fromSeconds(1),timeZoneService));

_this._$timeout=$timeout;
_this._$state=$state;

_this._uncaughtErrorHandler=uncaughtErrorHandler;
_this._dashboardDataService=dashboardDataService;
_this._userService=userService;
_this._analytics=Analytics;

_this.sortByFatigueAlertType=_this._sortByFatigueAlertType.bind(_this);
_this.searchQuery='';

_this._groupTreeService=groupTreeService;
_this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
_this._paramSyncService=paramSyncService;

_this.subViewConfiguration=_this._getSubViewConfiguration();

breadcrumbsService.startTrail('Dashboard');

groupTreeService.linkController(_this);

_this._updateUrlParamsFromController=paramSyncService.start(_this,$scope,function(newParams){return _this._updateControllerParamsFromUrl(newParams)});

_this._beginUpdates();return _this;
}DashboardController.prototype.

_updateControllerParamsFromUrl=function _updateControllerParamsFromUrl(newStateParams){
const{groupId:groupId}=newStateParams;

if(_.get(this.selectedGroup,'id')===groupId){
return;
}

this._groupTreeService.selectGroupWithId(groupId);
};DashboardController.prototype.


























_update=function(){var ref=_asyncToGenerator(function*(){
try{
yield this._dashboardDataService.update();
}catch(err){
if(err instanceof SocketTimeoutError||err instanceof UnexpectedError){
throw new UpdateFailedError;
}
throw err;
}
});function _update(){return ref.apply(this,arguments)}return _update}();DashboardController.prototype.





































sortByFatigueScore=function sortByFatigueScore(item){
return Math.floor(item.fatigueAlertScore)||Number.NEGATIVE_INFINITY;
};DashboardController.prototype.

_sortByFatigueAlertType=function _sortByFatigueAlertType(personViewModel){
let thresholdStatus=personViewModel.thresholdStatusFor(this.selectedNotificationType);

switch(thresholdStatus){
case ThresholdStatus.Above:
return 2;
case ThresholdStatus.At:
return 1;
default:
return Number.NEGATIVE_INFINITY;}

};DashboardController.prototype.





_getSubViewConfiguration=function _getSubViewConfiguration(){
let propsToBindToSubViews=[
'dashboardDataService',
'searchQuery',
'filteredPersons',
'sortByFatigueScore',
'sortByFatigueAlertType',
'groupTree',
'selectedGroup',
'selectedGroupData',
'selectedNotificationType'];


return ControllerExtensions(this).getMultiViewConfigurationFor(propsToBindToSubViews,[{
label:'List',
directiveName:'pulsar-dashboard-list'},
{
label:this._fatigueMeterTypeContentProviderService.heatmapButtonLabel,
directiveName:'pulsar-dashboard-heatmap'}]);

};_createClass(DashboardController,[{key:'groupTreeService',get:function(){return this._groupTreeService},set:function(groupTreeService){this._groupTreeService=groupTreeService}},{key:'$scope',get:function(){return this._$scope}},{key:'$state',get:function(){return this._$state}},{key:'stateName',get:function(){return'fdc.features.dashboard'}},{key:'dataService',get:function(){return this._dashboardDataService}},{key:'_lastFetchTime',get:function(){return this._dashboardDataService.lastFetchTime}},{key:'_isUpdating',get:function(){return this._dashboardDataService.isUpdating}},{key:'groupTree',get:function(){return this._dashboardDataService.groupTree}},{key:'estimatesAsOfTime',get:function(){return this._dashboardDataService.estimatesAsOfTime}},{key:'selectedGroup',get:function(){return this._groupTreeService.selectedGroup}},{key:'selectedGroupData',get:function(){return this._dashboardDataService.selectedGroupData}},{key:'selectedNotificationType',get:function(){return this._selectedNotificationType},set:function(selectedNotificationType){if(_.exists(this._selectedNotificationType)&&_.exists(selectedNotificationType)&&this._selectedNotificationType!==selectedNotificationType){this._analytics.trackEvent('ui','DashboardVisibleAlertTypeChanged',_.get(selectedNotificationType,'name',null))}this._selectedNotificationType=selectedNotificationType}},{key:'dashboardDataService',get:function(){return this._dashboardDataService}}]);return DashboardController}(BaseRealtimeUpdateController),(_applyDecoratedDescriptor(_class.prototype,'_update',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_update'),_class.prototype)),_class);


module.exports=DashboardController;
//# sourceMappingURL=dashboardController.js.map
